import { useState } from 'react';
import CookieConsent, { Cookies, getCookieConsentValue } from "react-cookie-consent";
import {
    MDBBtn,
    MDBSwitch,
    MDBModal,
    MDBModalDialog,
    MDBModalContent,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,
    MDBModalFooter,
} from 'mdb-react-ui-kit';

window.dataLayer = window.dataLayer || [];

const BmiCookieConsent = (props) => {
    const [cookiesModal, showCookiesModal] = useState(false);
    const [ccVisibility, setCcVisibility] = useState(true);
    const [performanceCookie, setPerformanceCookie] = useState(false);
    const [targetingCookie, setTargetingCookie] = useState(false);
    const bmiczCookie = getCookieConsentValue("BmiczCookieConsent");

    if (bmiczCookie != undefined) {
        var cookieValue = bmiczCookie.substring(7);
        var cookies = cookieValue.split(',');
        var perfCookie = cookies[1].slice(-1);
        if (perfCookie == 1) {
            gtag('consent', 'update', {
                'ad_storage': 'granted',
                'ad_user_data': 'granted',
                'ad_personalization': 'granted',
                'analytics_storage': 'granted'
            });
        }
    }

    function gtag() { window.dataLayer.push(arguments); }

    function consentAll() {
        gtag('consent', 'update', {
            'ad_storage': 'granted',
            'ad_user_data': 'granted',
            'ad_personalization': 'granted',
            'analytics_storage': 'granted'
        });
        var cookieValue = "groups=C0001:1,C0007:1,C0004:1"
        setCookie("BmiczCookieConsent", cookieValue, 365);
        setCcVisibility(false);
    }

    function denyAll() {
        gtag('consent', 'update', {
            'ad_storage': 'denied',
            'ad_user_data': 'denied',
            'ad_personalization': 'denied',
            'analytics_storage': 'denied'
        });
        var cookieValue = "groups=C0001:1,C0007:0,C0004:0"
        setCookie("BmiczCookieConsent", cookieValue, 365);
        setCcVisibility(false);
    }

    function acceptSelected() {
        var cookieValue = "groups=C0001:1";
        if (performanceCookie) {
            cookieValue += ",C0007:1";
            gtag('consent', 'update', {
                'ad_storage': 'granted',
                'ad_user_data': 'granted',
                'ad_personalization': 'granted',
                'analytics_storage': 'granted'
            });
        } else {
            cookieValue += ",C0007:0";
        }
        if (targetingCookie) {
            cookieValue += ",C0004:1";
        } else {
            cookieValue += ",C0004:0";
        }
        setCookie("BmiczCookieConsent", cookieValue, 365);
    }

    const cookiesModalBody = () => {
        return (
            <div className="">
                <h2 className="nadpis">Centrum předvoleb ochrany osobních údajů</h2>
                <div className="mb-3">
                    <p className="text-secondary mb-0">
                        Při návštěvě jakékoli webové stránky je pravděpodobné, že stránka získá nebo uloží  informace na vašem prohlížeči, a to většinou ve formě souborů cookie. Můžou to být informace týkající se vás, vašich preferencí a zařízení, které používáte. Většinou to slouží k vylepšování stránky, aby fungovala podle vašich očekávání. Informace vás zpravidla neidentifikují jako jednotlivce, ale celkově mohou pomoci přizpůsobovat prostředí vašim potřebám. Respektujeme vaše právo na soukromí, a proto se můžete rozhodnout, že některé soubory cookie nebudete akceptovat. Když kliknete na různé tituly, dozvíte se více a budete moci nastavení změnit. Nezapomínejte ale na to, že zablokováním některých souborů cookie můžete ovlivnit, jak stránka funguje a jaké služby jsou vám nabízeny.</p>
                    <a className="content-link" href="https://www.bmigroup.com/cz/cookies/" target="_blank">cookie-policy</a>
                </div>
                <button className="btn btn-primary" onClick={() => {
                    showCookiesModal(false);
                    consentAll();
                }}>
                    Povolit vše
                </button>
                <section className="mt-5">
                    <h3 className="nadpis">Řízení předvoleb poskytování souhlasu</h3>
                    <div className="pb-4">
                        <div className="d-flex justify-content-between align-items-center">
                            <h4 className="fw-bold m-0 mx-2">Naprosto nezbytné soubory cookie</h4>
                            <div className="c-primary fw-bold fs-4">Vždy aktivní</div>
                        </div>
                        <div>
                            <p className="text-secondary mx-0 my-2 pe-5">
                                Jsou nezbytné k tomu, aby web fungoval, takže není možné je vypnout. Většinou jsou nastavené jako odezva na akce, které jste provedli, jako je požadavek služeb týkajících se bezpečnostních nastavení, přihlašování, vyplňování formulářů atp. Prohlížeč můžete nastavit tak, aby blokoval soubory cookie nebo o nich posílal upozornění. Mějte na paměti, že některé stránky bez těchto souborů nebudou fungovat. Tyto soubory cookie neukládají žádně osobní identifikovatelné informace.
                            </p>
                        </div>
                    </div>
                    <div className="pb-4">
                        <div className="d-flex justify-content-between align-items-center">
                            <h4 className="fw-bold m-0 mx-2">Soubory cookie pro zvýšení výkonu</h4>
                            <div className="form-check form-switch">
                                <MDBSwitch defaultChecked={performanceCookie}
                                    onClick={(e) => setPerformanceCookie(e.target.checked)} />
                            </div>
                        </div>
                        <div>
                            <p className="text-secondary mx-0 my-2 pe-5">
                                Pomáhají sledovat počet návštěvníků a také z jakého zdroje provoz pochází, což nám umožňuje zlepšovat výkon stránky. Můžeme s nimi určovat, které stránky jsou nejoblíbenější a které nejsou oblíbené, a také sledovat, jakým způsobem se návštěvníci na webu pohybují. Všechny informace, které soubory cookie shromažďují, jsou souhrnné a anonymní. Pokud soubory cookie nepovolíte, nebudeme vědět, kdy jste navštívili naši stránku.
                            </p>
                        </div>
                    </div>
                    <div className="pb-4">
                        <div className="d-flex justify-content-between align-items-center">
                            <h4 className="fw-bold m-0 mx-2">Cílené soubory cookie</h4>
                            <div className="form-check form-switch">
                                <MDBSwitch defaultChecked={targetingCookie}
                                    onClick={(e) => setTargetingCookie(e.target.checked)} />
                            </div>
                        </div>
                        <div>
                            <p className="text-secondary mx-0 my-2 pe-5">
                                Pomáhají sledovat počet návštěvníků a také z jakého zdroje provoz pochází, což nám umožňuje zlepšovat výkon stránky. Můžeme s nimi určovat, které stránky jsou nejoblíbenější a které nejsou oblíbené, a také sledovat, jakým způsobem se návštěvníci na webu pohybují. Všechny informace, které soubory cookie shromažďují, jsou souhrnné a anonymní. Pokud soubory cookie nepovolíte, nebudeme vědět, kdy jste navštívili naši stránku.
                            </p>
                        </div>
                    </div>
                </section>
            </div>
        );
    }

    const ccbuttons = () => {
        return (
            <div className=''>
                <button className='btn btn-outline col-md-auto col-12' onClick={() => showCookiesModal(true)}>Nastavení souborů cookie</button>
                <button className='btn btn-outline col-md-auto col-12' onClick={() => denyAll()}>Zamítnout vše</button>
                <button className='btn btn-primary col-md-auto col-12' onClick={() => consentAll()}>Přijmout všechny soubory cookie</button>
            </div>
        );
    }

    //console.log("cc", window.dataLayer[0][2]);
    return (bmiczCookie == undefined) ? (
        <span>
            <CookieConsent
                location="bottom"
                visible={ccVisibility}
                cookieName="BmiczCookieConsent"
                buttonText="Přijmout všechny soubory cookie"
                onAccept={() => consentAll()}
                disableStyles={true}
                containerClasses="cookie-consent-banner p-3"
                contentClasses="col-lg-6 col-12 align-items-center d-flex"
                buttonWrapperClasses="col-lg-6 col-12"
                ButtonComponent={ccbuttons}
            >
                <p className="small">
                    Když kliknete na „Přijmout všechny soubory cookie“, poskytnete tím souhlas k jejich ukládání na vašem zařízení,
                    což pomáhá s navigací na stránce, s analýzou využití dat a s našimi marketingovými snahami.&nbsp;
                    <a href="https://www.bmigroup.com/cz/cookies/" className="content-link">cookie-policy</a>
                </p>
            </CookieConsent>
            <MDBModal open={cookiesModal} tabIndex='-1' onClose={() => showCookiesModal(false)}>
                <MDBModalDialog scrollable size='lg'>
                    <MDBModalContent className='p-2'>
                        <MDBModalHeader>
                            <MDBModalTitle className='text-uppercase'>Nastavení souborů cookie</MDBModalTitle>
                            <MDBBtn className='btn-close' color='none' onClick={() => showCookiesModal(false)}></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody>
                            {cookiesModalBody()}
                        </MDBModalBody>
                        <MDBModalFooter>
                            <button className='btn btn-secondary' onClick={() => {
                                showCookiesModal(false);
                                denyAll();
                            }}>
                                Zamítnout vše
                            </button>
                            <button className=' btn btn-primary' onClick={() => {
                                showCookiesModal(false);
                                acceptSelected();
                            }}>
                                Potvrdit moje volby
                            </button>
                        </MDBModalFooter>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>
        </span>
    ) : (<span></span>);

}

export default BmiCookieConsent;


function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/;SameSite=None; Secure";
}

function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}